import PropTypes from "prop-types";
import React, { Suspense, useEffect } from "react";
import { Provider } from "react-redux";
import Loader from "../components/shared/Loader";
import MiddlewareWrapper from "../components/shared/MiddlewareWrapper";
import { Toaster } from "react-hot-toast";

import { MainProvider } from "../contexts/MainContext";
import AppRouter from "../utils/router";
import store from "../utils/store";
import { setJwtToken } from "../utils/api";
import { setJwtTokenToIosStore } from "../utils/iosHelper";

const RootPage = ({
  jwtToken,
  currentGroupId,
  currentUserId,
  groups,
  supportedCurrencies,
}) => {
  useEffect(() => {
    if (jwtToken) {
      setJwtToken(jwtToken);
      setJwtTokenToIosStore(jwtToken);
    }
  }, [jwtToken]);

  return (
    <MainProvider
      jwtToken={jwtToken}
      currentGroupId={currentGroupId}
      currentUserId={currentUserId}
      groups={groups}
      supportedCurrencies={supportedCurrencies}
    >
      <Provider store={store}>
        <Toaster />
        <Suspense fallback={<Loader className="min-h-screen" />}>
          <MiddlewareWrapper>
            <AppRouter />
          </MiddlewareWrapper>
        </Suspense>
      </Provider>
    </MainProvider>
  );
};

RootPage.propTypes = {
  jwtToken: PropTypes.string.isRequired,
  currentGroupId: PropTypes.number,
};

export default RootPage;
